import type { Facet } from "~/lib/algolia/types"
import type { CheckboxType } from "~/components/ui/Panels/Filters/components/Facet"

export const CHECKBOX_TYPE_BY_NAME: Record<Facet, CheckboxType> = {
  facet_apparel: "List",
  facet_color: "Swatch",
  facet_discount: "Box",
  facet_size: "Box",
  facet_size_shoes: "Box",
  // [ALLOWED_FACETS.categories]: "List",
  // [ALLOWED_FACETS.promotion]: "Box",
  // [ALLOWED_FACETS.discount]: "List",
  // [ALLOWED_FACETS.sorting]: "Radio",
} as const
